import { z } from 'zod';

export const recordingAnalysisStatusSchema = z.enum(['processing', 'ready', 'failed']);

export type RecordingAnalysisStatus = z.infer<typeof recordingAnalysisStatusSchema>;

const rpaRecordingSummarySchema = z.object({
  recording_id: z.string(),
  skill_id: z.string().optional(),
  name: z.string(),
  workflow_name: z.string().nullable().optional(),
  status: recordingAnalysisStatusSchema,
  created_at: z.string(),
  completed_at: z.string().nullable().optional(),
  error_code: z.string().nullable().optional(),
  idempotency_key: z.string().nullable().optional(),
});

const rpaTeamWorkflowSummarySchema = z.object({
  recording_id: z.string(),
  skill_id: z.string().optional(),
  team_id: z.string().optional(),
  name: z.string(),
  workflow_name: z.string().nullable().optional(),
  source_recording_id: z.string().optional(),
  created_at: z.string(),
  updated_at: z.string().nullable().optional(),
  promoted_at: z.string().nullable().optional(),
});

export const rpaUserWorkflowsResponseSchema = z
  .object({
    personal_recordings: z.array(rpaRecordingSummarySchema).default([]),
    team_workflows: z.array(rpaTeamWorkflowSummarySchema).default([]),
  })
  .passthrough();

export type RpaUserWorkflowsResponse = z.infer<typeof rpaUserWorkflowsResponseSchema>;

export const recordingWorkflowDetailResponseSchema = z.object({
  status: recordingAnalysisStatusSchema,
  workflow_data: z.unknown().nullable().optional(),
  workflowData: z.unknown().nullable().optional(),
  error_code: z.string().nullable().optional(),
  errorCode: z.string().nullable().optional(),
});
